import { IMetadata } from '../../interfaces/common';
import { getApiCached } from '../../utils/api';

export interface INextAvailableAppointment extends IMetadata {
  nextAvailableAppointmentId: number;
  nextAvailableAppointmentDescription: string;
}

export const getNextAvailableAppointments = () =>
  getApiCached<INextAvailableAppointment[]>('lookup/NextAvailableAppointments');
